import { useSetAtom } from "jotai/react";

import { APPLICATION_FLOW_DEFAULT_STEPS } from "@/domain/applications";
import {
  applicationCurrentStepAtom,
  applicationTotalStepsAtom,
  dashboardScenarioAtom,
  dismissedDashboardCardIdsAtom,
  emailForSigninAtom,
  hasCompletedRegistrationAtom,
  lastSyncedEligibilityDataAtom,
  mfaResolverAtom,
  mfaVerificationIdAtom,
  needsToCreatePasswordAtom,
  onboardingShortCodeDataAtom,
  pendingLanguageAtom,
  submissionConfirmationApplicationIdsAtom,
} from "@/stores/atoms";

/**
 * Returns a function that resets all account-specific atoms to their defaults.
 * Call this on sign-out to prevent stale state when switching accounts.
 *
 * Preserved atoms (not reset): localeAtom, themeAtom, currentStateAtom,
 * isManualLogoutAtom, isSessionExpiredAtom, completedOnboardingMemberIdsAtom.
 */
export const useResetAtoms = () => {
  const setHasCompletedRegistration = useSetAtom(hasCompletedRegistrationAtom);
  const setApplicationCurrentStep = useSetAtom(applicationCurrentStepAtom);
  const setLastSyncedEligibilityData = useSetAtom(
    lastSyncedEligibilityDataAtom,
  );
  const setOnboardingShortCodeData = useSetAtom(onboardingShortCodeDataAtom);
  const setNeedsToCreatePassword = useSetAtom(needsToCreatePasswordAtom);
  const setEmailForSignin = useSetAtom(emailForSigninAtom);
  const setMfaVerificationId = useSetAtom(mfaVerificationIdAtom);
  const setMfaResolver = useSetAtom(mfaResolverAtom);
  const setApplicationTotalSteps = useSetAtom(applicationTotalStepsAtom);
  const setDismissedDashboardCardIds = useSetAtom(
    dismissedDashboardCardIdsAtom,
  );
  const setDashboardScenario = useSetAtom(dashboardScenarioAtom);
  const setPendingLanguage = useSetAtom(pendingLanguageAtom);
  const setSubmissionConfirmationApplicationIds = useSetAtom(
    submissionConfirmationApplicationIdsAtom,
  );

  const resetAll = () => {
    setHasCompletedRegistration(false);
    setApplicationCurrentStep(1);
    setApplicationTotalSteps(APPLICATION_FLOW_DEFAULT_STEPS);
    setLastSyncedEligibilityData("");
    setOnboardingShortCodeData(null);
    setNeedsToCreatePassword(false);
    setEmailForSignin(null);
    setMfaVerificationId(null);
    setMfaResolver(null);
    setDismissedDashboardCardIds([]);
    setDashboardScenario(null);
    setPendingLanguage(null);
    setSubmissionConfirmationApplicationIds([]);
  };

  return resetAll;
};
